window.PurLinkInList = {
	
	init : function(doctype){
		
		purchaseTools.prepareLinkForm("purchaseLinkInList");
		
		$("#submitLink").click(function(){
			$("#purchaseLinkInList").submit();
		});
		
		var $linkForm = $('#purchaseLinkInList');
		
		if($('.linkedContainer li:visible').length > 0){
			$("#submitLink").show();
			$(".placeholder").hide();
		}else{
			$(".placeholder").show();
			$("#submitLink").hide();
		}

		switch (doctype){
			
			case "purchase":
				
				$(document).off('change', '.listing tbody tr input:checkbox').on('change', '.listing tbody tr input:checkbox', function(e){
					
					$('.listing tr.linkInListClicked').removeClass('linkInListClicked');
					$(this).toggleClass('linkInListClicked');
					
					var numformat = NumberFormat.loadFromInputs('num_');
						
					var actionCheck = $(this);
					
					if (!actionCheck.is(':checked')){

						actionCheck.attr('checked', false);
						
						var $linked = $('.linked', $linkForm);
						$linked.hide();
						$('#purchaseLinkInList #purchaselink_purchase_id').val(0);
						
					} else {
						var source_amount	= parseFloat($('#source_totalAmount').data('totalamounttaxesfree'));
						var toLink_amount	= parseFloat(actionCheck.attr('link-amount-raw'));

						$('.listing tbody tr input:checkbox').prop('checked', false);
						actionCheck.prop('checked', true);

						// => On récupère les 
						var $linked = $('.linked.template', $linkForm).show();
						var purID = actionCheck.attr('id');

						var $linked = $('.linked', $linkForm);
						$linked.show();
						$linked.attr('id', 'linked-'+purID);

						$linked.find('.linked-ident').html(actionCheck.attr('link-ident'));
						$linked.find('.linked-amount').html(actionCheck.attr('link-amount'));

						var amount = parseFloat(actionCheck.data('amountTaxesFree'), 10);
						
						$linked.appendTo('.linkedContainer').show();
						MyFacture.customForm('.linked');

						var final_amount = Math.min(source_amount, toLink_amount);
						$linked.find('#purchaselink_linked-amount').val(NumberFormat.formatToDisplay(final_amount, numformat));

						$('#purchaseLinkInList #purchaselink_purchase_id').val(actionCheck.attr('id'));
					}
					
					if($('.linkedContainer li:visible').length > 0){
						$("#submitLink").show();
						$(".placeholder").hide();
					}else{
						$(".placeholder").show();
						$("#submitLink").hide();
					}
					e.stopPropagation();
					e.preventDefault();
				});
				break;
			default:
				$(document).off('change', '.listing tbody tr input:checkbox').on('change', '.listing tbody tr input:checkbox', function(e){

					$('.listing tr.linkInListClicked').removeClass('linkInListClicked');
					$(this).toggleClass('linkInListClicked');

					var actionCheck = $(this);
					
					if (!actionCheck.is(':checked')){
						
						actionCheck.attr('checked', false);
						
						var $linked = $('.linked', $linkForm);
						$linked.hide();
						$('#purchaseLinkInList #purchaselink_'+doctype+'_id').val(0);
						
					} else {
						
						$('.groupedActionChecker').attr('checked', false).next().removeClass('ui-state-active');
						actionCheck.attr('checked', true);
						var docID = actionCheck.attr('id');
						var $linked = $('.linked', $linkForm);
						$linked.show();
						$linked.attr('id', 'linked-'+docID);
						
						$linked.find('.linked-ident').html(actionCheck.attr('link-ident'));
						$linked.find('.linked-amount').html(actionCheck.attr('link-amount'));
						
						$('#purchaseLinkInList #purchaselink_'+doctype+'_id').val(docID);
						MyFacture.initEvent();
					}

					if($('.linkedContainer li:visible').length > 0){
						$("#submitLink").show();
						$(".placeholder").hide();
					}else{
						$(".placeholder").show();
						$("#submitLink").hide();
					}
					e.stopPropagation();
					e.preventDefault();
					return false;

				});
				break;
		}
		
		$('.listing tbody tr td').removeAttr('onclick');
		
		$(document).off('click', '.listing tbody tr td:not(.groupedActionCheckerContainer)').on('click', '.listing tbody tr td:not(.groupedActionCheckerContainer)', function(e){
			
			e.stopPropagation();
			e.preventDefault();
					
			var checker = $(this).closest('tr').find('input:checkbox');
			checker.prop('checked', !checker.prop('checked'));
			checker.trigger('change');
			
			return false;
		});

		
	}

};

window.Purchases = {

	numformat : {'name':"", 'currency':"", 'decimals':"", 'thousands':"", 'currencypos':"", 'position':""},

    addRow: function(data){
		
		$('.noDocument').parent().remove();
		
		var toInject = data == undefined ? {} : data;
		var numberFormat = Purchases.getNumFormat(true);
		
		var newRow = "";
		switch (toInject.type){
			case 'packaging' :
				newRow = $('.purchaseDetailPackagingRowMain').clone();
				newRow.removeClass('purchaseDetailPackagingRowMain');
				Purchases.changeItem("row_shippingId_"+(nbRows+1));
				
				// accountingPackagingCodesList
				newRow.find('.accounting_div').html($('#accountingPackagingCodesList').html());
				break;
			case 'shipping' :
				newRow = $('.purchaseDetailShippingRowMain').clone();
				newRow.removeClass('purchaseDetailShippingRowMain');
				
				// accountingShippingCodesList
				newRow.find('.accounting_div').html($('#accountingShippingCodesList').html());
				break;
			default :
				newRow = $('.purchaseDetailRowMain').clone();
				newRow.removeClass('purchaseDetailRowMain');
				break;
		}
		
		
		newRow.removeClass('hidden').addClass('purchaseDetailRow');
		
		if(toInject.purchaseAmount == undefined){
			toInject.purchaseAmount = 0;
		}
		
		var nbRows = $('.purchaseDetailRow').size();
		newRow.find('textarea[name*="row_notes"]').removeAttr('onClick').html(toInject.notes);
		newRow.find('input[name*="row_linkedid"]').removeAttr('onClick').val(toInject.linkedid);
		newRow.find('input[name*="row_declid"]').removeAttr('onClick').val(toInject.decl_id);
		newRow.find('input[name*="row_name"]').removeAttr('onClick').val(toInject.name);
		newRow.find('input[name*="row_unitAmount"]').removeAttr('onClick').val(NumberFormat.formatToDisplay(toInject.purchaseAmount, numberFormat));
		newRow.find('.row_analyticsCode').attr('value',toInject.analyticsCode); //+toInject.analyticsPurchaseCode
		
		if (!toInject.type){
			newRow.find('input[name*="row_type"]').removeAttr('onClick').val("once");
		} else {
			if (toInject.type == "packaging") {
				newRow.find('input[name*="row_name"]').removeAttr('onClick').val(Loc.g("Frais emballage"));
			} else if (toInject.type == "shipping") {
				newRow.find('input[name*="row_name"]').removeAttr('onClick').val(Loc.g("Frais de port"));
			} 
			newRow.find('input[name*="row_type"]').removeAttr('onClick').val(toInject.type);
		}
		
        $.each(newRow.find('*[name]'), function (index, aName){
            var splitted = $(this).attr('name').split('_');
            splitted[2] = nbRows+1;
            $(this).attr('name', splitted.join('_'));
        });

		$.each(newRow.find('*[id]'), function (index, aName){
            var splitted = $(this).attr('id').split('_');
            splitted[2] = nbRows+1;
            $(this).attr('id', splitted.join('_'));
		});
					
		$.each(newRow, function (index, aName){
			
			if ($('.tax_div', this).length > 0){
				var taxZone = $('.tax_div', this);
				var splittedTax = taxZone.attr('p_divvalue').split('|');
				var splitedId = splittedTax[1].split('_');
				splitedId[2] = nbRows+1;
				
				if(!toInject.taxid){
					toInject.taxid = splittedTax[0]
				}
				taxZone.attr('p_divvalue', toInject.taxid+'|'+splitedId.join('_'));				
				taxZone.find('select option').removeAttr("selected");
				taxZone.find('select option[value='+toInject.taxid+']').attr('selected', 'true');
			}
			
			if ($('.unit_div', this).length > 0){
				var unitZone = $('.unit_div', this);
				var splittedUnit = unitZone.attr('p_divvalue').split('|');
				var spliteUnitdId = splittedUnit[1].split('_');
				spliteUnitdId[2] = nbRows+1;
				if(!toInject.unitid){
					toInject.unitid = splittedUnit[0]
				}
				unitZone.attr('p_divvalue', toInject.unitid+'|'+spliteUnitdId.join('_'));
				unitZone.find('select option').removeAttr("selected");
				unitZone.find('select option[value='+toInject.unitid+']').attr('selected', 'true');
			}
			
			if ($('.accounting_div', this).length > 0){
				var accountZone = $('.accounting_div', this);
				var splittedAccounting = accountZone.attr('p_divvalue').split('|');
				var splittedAccountingId = splittedAccounting[1].split('_');
				splittedAccountingId[2] = nbRows+1;
				if(!toInject.accountingPurchaseCode){
					toInject.accountingPurchaseCode = splittedAccounting[0]
				}
				accountZone.attr('p_divvalue', toInject.accountingPurchaseCode+'|'+splittedAccountingId.join('_'));
				accountZone.find('select option').removeAttr("selected");
				accountZone.find('select option[value='+toInject.accountingPurchaseCode+']').attr('selected', 'true');
			}
			
        });
		
		if ($('#detail_analytics_code').length !== 0 && $('#analyticsType').val() == "doc"){
			newRow.find('.row_analyticsCode').val($('#detail_analytics_code').val());
		}
		
		$('#purchases_addForm .purchasesDetailRows').append(newRow);
        
		MyFacture.customForm();
        Purchases.bindElement();
        Purchases.calculateTotals();
		
		switch (toInject.type){
			
			case 'packaging' :
				Purchases.changeItem("row_packagingId_"+(nbRows+1));
				break;
				
			case 'shipping' :
				Purchases.changeItem("row_shippingId_"+(nbRows+1));
				break;
				
		}

        $('#nbrows').val($('.purchaseDetailRow').size());

    },

    deleteRow: function(row){
		var closestTr =  $(row).closest('tr');
		closestTr.find('.row_delete').val('Y');
		closestTr.hide();		
        Purchases.bindElement();
        Purchases.calculateTotals();
		
		if ($('.purchaseDetailRow:visible').length === 0){
			$('.noDocument').parent().slideDown('200');
		}
    },

    calculateTotals: function(){
	
		if ($('.purchaseDetailRow .row_name').length ===  0) return;
		
		var hasDoubleVat = $('#hasDoubleVat').val() === "Y";
        var numberFormat = Purchases.getNumFormat(true);
		
        var finalFree = NumberFormat.formatToFloat(0, numberFormat);
        var finalTotal = NumberFormat.formatToFloat(0, numberFormat);
        var totalFree = $('#pay_amount_free');
        var total = $('#pay_amount_total');
		var totalVat = [];
		
		var rows  = $('.purchaseDetailRow:visible');
		$.each (rows, function (index, row){

			var free = NumberFormat.formatToFloat($(row).find('.row_unitAmount').val(), numberFormat);
			var qt = NumberFormat.formatToFloat($(row).find('.row_qt').val(), numberFormat);
			
			finalFree = finalFree + (free*qt);
			
            finalTotal = finalTotal + NumberFormat.formatToFloat($(row).find('.row_totalTaxedAmount').val(), numberFormat);
			// vat1
			var vatId = $(row).find('.tax_div option:selected').val();
			var vatValue = $(row).find('.tax_div option:selected').attr('rate');
			if (typeof(vatValue) !== "undefined"){
				vatValue = NumberFormat.formatToFloat(vatValue, numberFormat);
				var vatAmount = (free * qt) * (vatValue/100);
				if(totalVat[vatId] === undefined){
					totalVat[vatId] = {};
					totalVat[vatId].sum = 0;
					totalVat[vatId].tax = vatValue;
				}
				totalVat[vatId].sum += parseFloat(vatAmount,10);
			}
			if (hasDoubleVat){
				// vat2
				var vatId2 = $(row).find('.tax2_div option:selected').val();
				var vatValue2 = $(row).find('.tax2_div option:selected').attr('rate');
				if (typeof(vatValue2) !== "undefined"){
					vatValue2 = NumberFormat.formatToFloat(vatValue2, numberFormat);
					var vatAmount2 = (free * qt) * (vatValue2/100);
					if(totalVat[vatId2] === undefined){
						totalVat[vatId2] = {};
						totalVat[vatId2].sum = 0;
						totalVat[vatId2].tax = vatValue2;
					}
					totalVat[vatId2].sum += parseFloat(vatAmount2,10);
				}
			}
			
		});
		$(totalFree).val(NumberFormat.formatToDisplay(finalFree, numberFormat));
        $(total).val(NumberFormat.formatToDisplay(finalTotal, numberFormat));
		
		$('#purchases_addForm .overviewTotals .totalTaxe').remove();
		
		for (var i in totalVat){
			var formatedSum = NumberFormat.formatToDisplay(totalVat[i]['sum'], numberFormat);
			var htmlTax = '<tr class="totalTaxe"><td class="labels"><label>TVA [ '+totalVat[i]['tax']+'% ] :</label></td><td class="totals"><span class="currencyleft"></span><input type="text" value="'+formatedSum+'" autocomplete="off" class="updateRow" readonly="readonly"><span class="currencyright"></td></tr>';
			$('#purchases_addForm .overviewTotals .totalFree').after(htmlTax);
		}

    },

    bindElement: function(){
		
		$('#detail_third_supplieraddrid').unbind().change(function(){Purchases.autoSuppliersAddressChange();});
		$('.addRowFromCatalog').unbind().click(function(){Catalogue.loadCatalogue('purchase', 'Y');});
        $('.addPurchasesRow').unbind().click(function(){Purchases.addRow();});
        $('.addShippingRow').unbind().click(function(){Purchases.addRow({'type' : 'shipping'});});
        $('.addPackagingRow').unbind().click(function(){Purchases.addRow({'type' : 'packaging'});});
		
        $('.deletePurchaseRow').unbind().click(function(){Purchases.deleteRow(this)});

        $('.row_unitAmount').unbind().change(function(){
            Purchases.transformFreeToVAT(this, false);
        });
		
        $('.row_qt').unbind().change(function(){
            Purchases.transformFreeToVAT(this, false);
        });
        $('.row_totalTaxedAmount').unbind().change(function() {
            Purchases.transformFreeToVAT(this, true);
        });
        $('.tax_div').find('select').unbind().change(function(){
            Purchases.transformFreeToVAT(this, false);
            var newVal = $(this).find('option:selected').val();
            var val = $(this).parent().attr('p_divvalue').split('|');
			$(this).parent().attr('p_divvalue', newVal+'|'+val[1]);
        });
        $('.tax2_div').find('select').unbind().change(function(){
            Purchases.transformFreeToVAT(this, false);
            var newVal = $(this).find('option:selected').val();
            var val = $(this).parent().attr('p_divvalue').split('|');
			$(this).parent().attr('p_divvalue', newVal+'|'+val[1]);
        });
		
		$('.purchaseDetailRow.contentGray *').attr("readonly", "readonly").removeAttr('onClick').unbind().bind('click change',function(){
			MyWindow.alert(Loc.g("Cette ligne ne peux pas être modifiée car elle est présente dans une facture fournisseur."), {type:'error'});
			return false;
		});
		
		//store the original selection
		$(".purchaseDetailRow.contentGray select :selected").each(function(){
			$(this).parent().data("default", this);
		});

		//change the selction back to the original
		$(".purchaseDetailRow.contentGray select").change(function(e) {
			$($(this).data("default")).prop("selected", true);
		});
		
    },

	catalogCallback: function(data){
		for (var i in data.rows) {
			Purchases.addRow(data.rows[i]);
			var current = $('.purchaseDetailRow:last');
			Purchases.transformFreeToVAT(current);
		}
		Purchases.calculateTotals();
	},

    transformFreeToVAT: function(ref, VATtoFree){
		var hasDoubleVat	= $('#hasDoubleVat').val() === "Y";
        var numberFormat	= Purchases.getNumFormat(true);
        var closestTr		= $(ref).closest('tr');		
        var amountTotal		= closestTr.find('.row_totalTaxedAmount');
        var amountTotalFree = closestTr.find('.row_totalAmount');
        var amountQt		= closestTr.find('.row_qt');
        var amountFree		= closestTr.find('.row_unitAmount');
        var vat				= closestTr.find('.tax_div select :selected');
        var taxe			= new Big(NumberFormat.formatToFloat(vat.attr('rate'), numberFormat));
		var qt				= new Big(NumberFormat.formatToFloat(amountQt.val(), numberFormat));
		
		if (hasDoubleVat){
			var vat2 = closestTr.find('.tax2_div select :selected');
			var taxe2 = NumberFormat.formatToFloat(vat2.attr('rate'), numberFormat);
			var freeTaxe = NumberFormat.formatToFloat(amountFree.val(), numberFormat);
			var newTax =  (freeTaxe * qt) * (taxe/100);
			var newTax2 =  (freeTaxe * qt ) * (taxe2/100);
			var newTaxFinal = (freeTaxe * qt) + newTax + newTax2;
			amountTotalFree.val(NumberFormat.formatToDisplay(qt*freeTaxe, numberFormat));
			amountTotal.val(NumberFormat.formatToDisplay(newTaxFinal, numberFormat));
			amountFree.val(NumberFormat.formatToDisplay(freeTaxe, numberFormat));
		} else {
			if (VATtoFree){
				var totalTTC = new Big(NumberFormat.formatToFloat(amountTotal.val(), numberFormat));
				var unitHT = (totalTTC.div(qt)).div(taxe.div(100).plus(1));

				amountTotalFree.val((unitHT.times(qt)).round(2));
				amountFree.val(NumberFormat.formatToDisplay(unitHT.round(2).toString(), numberFormat));
				amountTotal.val(NumberFormat.formatToDisplay(totalTTC.round(2).toString(), numberFormat));
			} else {
				var freeTaxe = NumberFormat.formatToFloat(amountFree.val(), numberFormat);
				var newTaxe = qt*freeTaxe*( 1+(taxe/100));
				amountTotalFree.val(NumberFormat.formatToDisplay(qt*freeTaxe, numberFormat));
				amountTotal.val(NumberFormat.formatToDisplay(newTaxe, numberFormat));
				amountFree.val(NumberFormat.formatToDisplay(freeTaxe, numberFormat));
			}
		}
		
		amountQt.val(NumberFormat.formatToDisplay(qt, numberFormat));

        Purchases.calculateTotals();
    },

	changeItem : function(itemsListId){
		var parts = itemsListId.split("_");
		var position	= parts[parts.length-1];
		var selected = $("#"+itemsListId+" option:selected");
		if($("#detail_analytics_code").css('display') === 'none'){
			$("input[name=row_analyticsCode_"+position+"]").val(selected.attr("analyticsCode"));
		}else{
			$("#row_analyticsCode_"+position).val($("#docAnalyticsCode").val());
		}
		$("#row_accountingCode_"+position+" option").removeAttr('selected');
		$("#row_accountingCode_"+position+" option[value="+selected.attr("accountingPurchaseCode")+"]").attr('selected', 'selected');
		$("#row_qt_"+position).val(selected.attr("qt"));
		$("#row_taxeId_"+position).val(selected.attr("taxid"));
	},

	refreshNumFormat : function(){
		Purchases.numformat.name			= "";
		Purchases.numformat.currency		= $('select[name=currency] option:selected').html();
		Purchases.numformat.decimals		= $("#num_decimals").val();
		Purchases.numformat.thousands		= $("#num_thousands").val();
		Purchases.numformat.currencypos		= $("#num_currencypos").val();
		Purchases.numformat.precision		= parseInt($("#num_precision").val(), 10);
	},

	getNumFormat : function(reload){
		if(reload === true){
			Purchases.refreshNumFormat();
		}
		return Purchases.numformat;
	},

	toggleShippingAddBlock: function() {
		if($("input[name=shipAddressType]:checked").val() == "corp") {
			$("#shipAddressCorpDiv").show("fast");
			$("#shipAddressThirdDiv").hide("fast");
		}else {

			if($("#shipthirdid").val() === "") {
				$("#thirdShipAddress_div .editAddress").hide();
			}
			
			$("#shipAddressThirdDiv").show("fast");
			$("#shipAddressCorpDiv").hide("fast");
		}
	},

	loadThirdAdr: function() {
		
		var thirdid = $("#shipthirdid").val();
		
		if(thirdid === "") {
			$("#thirdShipAddress_div .editAddress").hide();
			$("#thirdShipAddress_toHTML").html("<span class='notFilled'>il n'y a pas encore d'adresse de livraison</span>");
			$("#thirdShipAddress_div .hidden input[type='hidden']").val("");
		}else {
			
			var datas = {
				action: "loadThirdAdr",
				thirdid: thirdid
			};

			MyFacture.post("purchases_purchases", datas, function(data) {
				
				if(data.parts){
					
					var addressDetails = {};
					var fieldToLoad = ["name", "part1", "part2", "part3", "part4", "zip", "town", "countrycode","state"];
					var field = null;

					for(var f=0; f < fieldToLoad.length; f++){
						field = fieldToLoad[f];
						addressDetails[field] = data.parts[field];
					}

					if(data.addrid){
						addressDetails.originalid = data.addrid;
					}

					if(data.toHTML){
						addressDetails.toHTML = data.toHTML;
					}
					

					DocFormv2.setAddress("thirdShip", addressDetails);
				}
			}, "json");
			
			$("#thirdShipAddress_div .editAddress").show();
		}
	},
};

window.purchaseTools = {
	
	initMarge : function(){
		
		$.each($('.marge-container.withQtip'), function(k,v){
			var me = $(v);
			
			me.qtip({
				style : {
					classes : 'custom-qtip',
					def		: false
				},
				position: {
					viewport: true
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout', 
					fixed: true,
					delay: 100
				},
				content: {
					text : me.find('.qtip-margecontent')
				}
			});
			
		});
	},

	showLinkedTo : function(linkedType, linkedId){
		var options = {
			title	: Loc.g("Liste des documents liés à l'achat"),
			buttons	: [
				{text : Loc.g("Fermer"), click : function(){$(this).dialog("close")}}
			],
			callback	: function(){purchaseTools.prepareLinkForm();}
		};
		
		var fileOpt = {action:"prepareShowLinked",linkedType:linkedType,linkedId:linkedId};
		MyWindow.load("purchases_link", fileOpt, options);
	},

	linkTo : function(doctype, docid){
		var title = "";
		if(doctype === "purInvoice" || doctype === "purDelivery") {
			title = Loc.g("Lier un document à cet achat");
		}else {
			title = Loc.g("Lier un achat à un document");
		}
		
		var options = {
			dialogClass : "white",
			title	: title,
			buttons	: [
                {
                    text : Loc.g("Annuler"),
                    click : function(){$(this).dialog("close")}
                },
			],
			callback	: function(){purchaseTools.prepareLinkForm();}
		};
		
		var fileOpt = {action:"preparelinkform",doctype:doctype,docid:docid};
		MyWindow.load("purchases_link", fileOpt, options);
	},

	prepareLinkForm: function(formid){
		
		var formId	= (formid == undefined) ? "purchaseLink" : formid;
		var options = {success:function(data){purchaseTools.recordLinkCallback(data);}, dataType:"json"};
		var params	= {action:'recordlinkform'};
		MyForm.prepare(formId, "purchases_link&"+$.param(params), options, true);
		MyFacture.initEvent("#"+formId);
		
		if (formId === "purchaseLink"){
			$('.tolinkdoctype').change(function(){
				var show = $(this).val();
				$('.autocompletedoc').hide();
				$('#autocomplete_'+show).show();
			});
			purchaseTools.initEvent();
		}
	},

	recordLinkCallback: function(data){
		var formIsOk = MyForm.processJson(data, data.form.formId);		
		$('#error_currency').hide();

		if(formIsOk){
			if (data.redirect){
				Utils.relocate(data.redirect);
			} else {
				Utils.relocate(window.location.href.replace(/&tab=margins/g, '')+'&tab=margins');
			}
		} else {
			if(data.form.status == 'failed') {
				// currency error
				if(data.form.fields[0].fieldId == 'purchaselink_currency') {
					$('#error_currency').show();
				}
			}
		}
	},

	initEvent: function(){
		
		$('*[e_autopurchaselisting]').each(function(){if($(this).css('display')!='none') purchaseTools.autoPurchaseListing(this, $(this).attr('e_autopurchaselisting'), $(this).attr('e_autopurchaselisting_max'), $(this).attr('e_autopurchaselisting_searchonfocus'), $(this).attr('e_autopurchaselisting_more'))});	
	
	},

	autoPurchaseListing: function(field, type, max, searchOnFocus, more){
		
		var max				= undefined == max ? 20 : max;
		var more			= undefined == more ? '' : more;
		var id				= $(field).attr('id');
		var part			= id.split('_');

		var options = {
			id				: '#'+id,
			page			: 'purchases_link',
			url				: '&type='+type,
			action			: 'autocompletion',
			searchOnFocus	: false,
			min				: 3,
			tokenLimit		: max,
			addNew			: false,
			hintText		: Loc.g('Saisir numéro du document'),
			prePopulate		: Persistent.get(id,true,false),
			more 			: more,
		};

		if(searchOnFocus){
			options.searchOnFocus = true;
		}

		options.onAdd = function(item) {
			if (type == "purchase"){
				$('.linked-amount .total-linked-amount strong').html(item.formatted_pay_amount_free);
				$('#purchaselink_linked-amount').val(item.pay_amount_free);
				$('.linked-amount').toggle();
				MyFacture.initEvent();
				$('#purchaselink_linked-amount').trigger('change')
			}
		};
		options.onDelete = function(item) {
			if (type == "purchase"){
				$('.linked-amount .total-linked-amount strong').html('');
				$('#purchaselink_linked-amount').val('');
				$('.linked-amount').toggle();
			}
		};

		TokenInput.create(options);
	},

	askUnlik: function(linkId){
		var msg =  Loc.g("Vous allez délier l'élément du document, voulez-vous continuer ?");
		var options = {
			type		: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Délier un élément"),
			buttons		: [
                {text: Loc.g("Non"), click : function(){$(this).dialog("close");}},
                {text: Loc.g("Oui"), click : function(){purchaseTools.unlik(linkId);$(this).dialog("close");}},
			]
		};

		MyWindow.alert(msg, options);
	},

	unlik : function(linkId){	
		MyFacture.post('purchases_link&action=unLinkOne', {'linkId': linkId}, function(data){
			if (data.status == "ok"){
				$('.link_'+linkId).remove();
				purchaseTools.initMarge();
				MyWindow.close();
			} else {
                Utils.reload();
            }
		}, "json");
	}
};

window.FastPurchase = {

    init: function() {
        var options = {
            dataType		: "json",
            beforeSubmit	: function(){MyForm.clean('fastpurchaseform');},
            beforeSend		: function() {},
            uploadProgress	: function(event, position, total, percentComplete) {},
            success			: function(data) {
                FastPurchase.recordFastPurchase(data);
            }
        };
        
        $('#fastpurchaseform').ajaxForm(options);
        MyFacture.customForm();
        FastPurchase.updateTotal($(this));
        
        $("#fastpurchaseform").on('change', '.row_tax_main select, .rowHT, .row_tax2 select', function() {
            FastPurchase.updateTotal($(this));
        });
        
        $("#fastpurchaseform").on('change', '.rowTTC', function(e){
            var $purBlock	= $(this).closest('.purchaseBlock');
            var line		= $(this).closest('.fastPurchaseForm-table-row');

            if($purBlock.find('.doublevat').val() == 'Y'){
                e.preventDefault();
            } else {
                var numberFormat = NumberFormat.loadFromInputs("numformat_");
                var amountTTC = Big(NumberFormat.formatToFloat($(this).val(), numberFormat));
                var taxrate = Big(0);
                if ($purBlock.find('.taxesInc').val() == 'Y') {
                    taxrate = Big(NumberFormat.formatToFloat(line.find('.row_tax_main select option:selected').attr('rate'), numberFormat));
                }
                var lineHT = amountTTC.div(taxrate.div(100).plus(Big(1))).round(2);
                line.find('.rowHT').val(NumberFormat.formatToDisplay(lineHT.toString(), numberFormat));
            }

            FastPurchase.updateTotal($(this));
        });
    },

	toggleStep: function(step){

		if (step == "supinvoice" && $('#purchaseAdd-payment').val() == "N" && $('#purchaseAdd-supinvoice').val() == "N"){
			MyWindow.alert(Loc.g("Vous devez ajouter un paiement avant d’ajouter une facture fournisseur"), {type:'error'});
			return false;
		}
		
		if (step == "payment" && $('#purchaseAdd-supinvoice').val() == "Y"){
			
			$('.supinvoice-header a.enable').show();
			$('.supinvoice-header span').hide();
			$('#purchaseAdd-supinvoice').val("N");
			$('.supinvoice-container').hide(); 
			
		}

		if ($('#purchaseAdd-'+step).val() == "N"){
			
			$('.' + step + '-header a.enable').hide();
			$('.' + step + '-header span').show();
			$('#purchaseAdd-'+step).val("Y");
			$('.'+step+'-container').show(); 
			MyFacture.customForm();
			
		} else {
			
			$('.' + step + '-header a.enable').show();
			$('.' + step + '-header span').hide();
			$('#purchaseAdd-'+step).val("N");
			$('.'+step+'-container').hide(); 
			
		}
		
	},

	switchType : function(elem) {
		var $purBlock = elem.closest('.purchaseBlock');
		var coloneHT = $purBlock.find(".rowHT");
		var coloneTTC = $purBlock.find(".rowTTC");
		
		if(elem.val() === "Y") {
			coloneTTC.prop("readonly", false);
			coloneHT.prop("readonly", true);
		}else {
			coloneHT.prop("readonly", false);
			coloneTTC.prop("readonly", true);
		}
		
		FastPurchase.updateTotal($(this)); 
	},

	updateTotal : function(elem){
        var numberFormat = NumberFormat.loadFromInputs("numformat_");
		var totalHT		= Big(0);
		var totalTaxes	= Big(0);
		var totalTTC	= Big(0);
		var taxes		= [];
		
		var indice = elem.attr("indice");
		var $purBlock = elem.closest('.purchaseBlock');
		
		$purBlock.find('.fastPurchaseForm-table-row').each(function(){
			var amountHT = Big(NumberFormat.formatToFloat($(this).find('.rowHT').val(), numberFormat));
			
			if($purBlock.find('.hasvat').val() == 'Y'){
				var taxid	 = $(this).find('.row_tax_main select option:selected').val();
				var taxlabel = $(this).find('.row_tax_main select option:selected').html();
				var taxrate	= Big(NumberFormat.formatToFloat($(this).find('.row_tax_main select option:selected').attr('rate'), numberFormat));
			}else {
				var taxid	 = 0;
				var taxlabel = "";
				var taxrate	 = Big(0);
			}
			
			totalHT = totalHT.plus(amountHT);

			if(taxes[taxid] === undefined){
				taxes[taxid] = {
					id				: taxid, 
					label			: taxlabel,
					rate			: Big(taxrate), 
					baseAmount		: new Big(0), 
					amount			: new Big(0)
				};
			}
			
			if($purBlock.find('.taxesInc').val() == 'N'){
				lineTTC = amountHT.plus(amountHT.times(taxes[taxid].rate).div(100).round(2));
			}else {
				lineTTC = Big(NumberFormat.formatToFloat($(this).find('.rowTTC').val(), numberFormat));
			}
			
			taxes[taxid].baseAmount = taxes[taxid].baseAmount.plus(amountHT);
			
			if($(this).closest('.purchaseBlock').find('.doublevat').val() == 'Y'){
				
				var tax2id	 = $(this).find('.row_tax2 select option:selected').val();
				var tax2label = $(this).find('.row_tax2 select option:selected').html();
				var tax2rate	= Big(NumberFormat.formatToFloat($(this).find('.row_tax2 select option:selected').attr('rate'), numberFormat));
				
				if(taxes[tax2id] === undefined){
					taxes[tax2id] = {
						id				: tax2id, 
						label			: tax2label,
						rate			: Big(tax2rate), 
						baseAmount		: new Big(0), 
						amount			: new Big(0)
					};
				}
				
				taxes[tax2id].baseAmount = taxes[tax2id].baseAmount.plus(amountHT);
				lineTTC = lineTTC.plus(amountHT.times(taxes[tax2id].rate).div(100).round(2));
			}
			
			if($purBlock.find('.taxesInc').val() == 'N'){
				$(this).find('.rowTTC').val(NumberFormat.formatToDisplay(lineTTC, numberFormat));
			}else {
				totalTTC = totalTTC.plus(lineTTC.round(2));
				var lineHT = lineTTC.div(taxes[taxid].rate.div(100).plus(Big(1))).round(2);
				$(this).find('.rowHT').val(NumberFormat.formatToDisplay(lineHT, numberFormat));
			}
		});
		
		if($purBlock.find('.taxesInc').val() == 'N'){
			
			for(var i in taxes){
				if (taxes[i].baseAmount !== undefined){
					taxes[i].amount = taxes[i].baseAmount.times(taxes[i].rate).div(100).round(2);

					totalTaxes = totalTaxes.plus(taxes[i].amount);
				}
			}
			totalTTC = totalHT.plus(totalTaxes);
		}
		
		
		$('#totalTTC_'+indice).html(NumberFormat.formatToDisplay(totalTTC, numberFormat)+" "+$("#fpur_currency_"+indice+" option:selected").attr("symbol"));
		$('#totalTTCrows_'+indice).val(totalTTC);

		if($("#purchaseBlock_"+indice+" .blockPayment").length === 1) {
			$('#payrow_payamount_'+indice+'_1').val(NumberFormat.formatToDisplay(totalTTC, numberFormat));
		}
	},

	recordFastPurchase: function(data){
		
		var formIsOk = MyForm.processJson(data, "fastpurchaseform");

		if(formIsOk){
			
			Utils.relocate("?_f="+data.gotoUrl);
			
		}else {
			if(data.identExist) {
				
				var options = {
					type			: 'warning',
					title			: Loc.g("Numéro de document existant"),
					noclose			: true,
					closeOnEscape	: function(){$(this).dialog("close");},
					width			: 600,
					height			: 140,
					buttons			: [
						{text : Loc.g("Modifier le document"), click : function(){
							$(this).dialog("close");
						}},
						{text : Loc.g("Suivre la numérotation et enregistrer"), click : function(){							
							$.each(data.identExist, function(e, i) {
								
								$("input#fpur_ident_"+e).removeClass("ui-state-error");
								$("input#fpur_ident_"+e).val(i);
								$("input#fpur_identhaschange_"+e).val(i);
							});
							
							$(this).dialog("close");
							$("#fastpurchaseform").submit();
						}}
					]
				};
	
				MyWindow.alert(Loc.g('Vous avez saisi un numéro de document existant. Souhaitez vous le modifier ?'), options);
			}
		}
	},

	transformFreeToVAT: function(VATtoFree, elem){
		
        var numberFormat = NumberFormat.loadFromInputs("numformat_");
		var payAmount = 0;
		
		var indice = elem.attr("indice");
		
		$('#purchaseBlock_'+indice+' .fastPurchaseForm-table-row').each(function(){
			
			var taxedSelector = $(this).find('.rowTTC');
			var freeSelector = $(this).find('.rowHT');
			var vatSelector = $(this).find('.row_tax_main select option:selected');
			var taxe = NumberFormat.formatToFloat(vatSelector.attr('rate'), numberFormat);
			
			 if (VATtoFree){
				var taxed = NumberFormat.formatToFloat(taxedSelector.val(), numberFormat);
				var newFree = taxed/1/(1+(taxe/100));
				payAmount += taxed;
				freeSelector.val(NumberFormat.formatToDisplay(newFree, numberFormat));
				taxedSelector.val(NumberFormat.formatToDisplay(taxed, numberFormat));
				
			 } else {
				 
				var freeTaxe = NumberFormat.formatToFloat(freeSelector.val(), numberFormat);
				var newTaxe = 1*freeTaxe*( 1+(taxe/100));
				payAmount += newTaxe;
				taxedSelector.val(NumberFormat.formatToDisplay(newTaxe, numberFormat));
				freeSelector.val(NumberFormat.formatToDisplay(freeTaxe, numberFormat));
			 }
			
		});
		
		$('#payrow_payamount_'+indice+'_1').val(NumberFormat.formatToDisplay(payAmount, numberFormat));
		$('#totalTTCrows_'+indice).val(NumberFormat.formatToFloat(payAmount, numberFormat));

		$('#totalTTC_'+indice).html(NumberFormat.formatToDisplay(payAmount, numberFormat)+" "+$("#fpur_currency_"+indice+" option:selected").attr("symbol"));

    },

    addRow: function(indice) {
        var nbRows = parseFloat($('#purchaseBlock_'+indice+' .fastPurchaseForm-rows #fast_nbrows').val());
        var datas = {action:"addRow", nbRows:nbRows, indice:indice};
        var thirds = $('#fpur_supplier_' + indice).tokenInput('get');

        if(thirds.length > 0) {
            datas.thirdid = thirds[0].id.split('_')[1];
        }

        MyFacture.post("purchases_fastpurchase", datas, function(data){
            nbRows = nbRows+1;
            var row = data.purchases_fastPurchaseRow;
            $('#purchaseBlock_'+indice+' .fastPurchaseForm-rows tbody').append(row);
            $('#purchaseBlock_'+indice+' .fastPurchaseForm-rows #fast_nbrows').val(nbRows);
            $('#row_accountingCode_'+indice+'_'+nbRows).val(data.accountingPurchaseCode);
            MyFacture.customForm('#purchaseBlock_'+indice+' .fastPurchaseForm-rows tbody .row_'+indice+'-'+nbRows);
            FastPurchase.switchType($('#purchaseBlock_'+indice+' .taxesInc'));
        }, "json");
    },

	addPayRow: function(indice){

		var nbRows =  parseFloat($('#purchaseBlock_'+indice+' .payments #fast_nbpayrows_'+indice).val());
		var datas = {action:"addPayRow", nbRows:nbRows, indice:indice};
		MyFacture.post("purchases_fastpurchase", datas, function(data){
			
			var numFormat = NumberFormat.loadFromInputs("numformat_");
			
			var totalPay = Big(0);
			
			$("#purchaseBlock_"+indice+" .payments .payAmount").each(function(i, e) {
				
				totalPay = totalPay.plus(Big(NumberFormat.formatToFloat($(e).val() ,numFormat)));
			});

			var totalRows = Big(NumberFormat.formatToFloat($('#totalTTCrows_'+indice).val(), numFormat));
			var amount = totalRows.minus(totalPay);
			
			var row = data.purchases_fastPurchasePayRow;
			$('#purchaseBlock_'+indice+' .payments').append(row);

			nbRows = nbRows+1;
			$('#purchaseBlock_'+indice+' .payments #fast_nbpayrows_'+indice).val(nbRows);

			$('#purchaseBlock_'+indice+' .payments .payrow_'+nbRows+' #payrow_payamount_'+indice+'_'+nbRows).val(amount);
			
			$('#purchaseBlock_'+indice+' .blockPayment.payrow_'+nbRows+' .fpur_paydate').val($("#fpur_date_"+indice).val());
			
			MyFacture.customForm('#purchaseBlock_'+indice+' .payments .blockPayment.payrow_'+nbRows);
			
		}, "json");

	},

	addPurInvoice: function() {
		
		var indice =  parseFloat($('#indice').val());
		var datas = {action:"addPurInvoice", indice:indice};
		MyFacture.post("purchases_fastpurchase", datas, function(data){
			var block = data.purchases_fastPurchaseTemplate;
			$('#fastpurchasesList').append(block);
			var newIndice = indice+1;
			$('#indice').val(newIndice);
			MyFacture.customForm("#purchaseBlock_"+newIndice);
			
			FastPurchase.updateTotal($("#purchaseBlock_"+newIndice));
			
			if($('#fastpurchasesList .purchaseBlock').length > 1) {
				$('.deletePurchaseButton').show();
			}
			
			$("html, body").animate({ scrollTop: $(document).height() }, 500);
			
		}, "json");
	},

	deleteRow: function(me){
		me.closest('tr').remove();
		FastPurchase.transformFreeToVAT(true, me);
	},

	deletePayRow: function(me){
		me.closest('div.blockPayment').remove();
	},

	updateDate: function(indice) {
		var date = $("#fpur_date_"+indice).val();
		$('#purchaseBlock_'+indice+' .blockPayment .fpur_paydate').val(date);
	},

	uploadedFile: function(data, indice) {
		if(data.file_infos != undefined) {
			
			$('#errors_'+indice).hide();
			
			if($("#fpur_file_"+indice).val() === "") {
				$("#fpur_file_"+indice).val(data.file_infos.file_id);
			}else {
				$("#fpur_file_"+indice).val($("#fpur_file_"+indice).val()+","+data.file_infos.file_id);
			}
			
			$("#fileList_"+indice).append("<li class=''><a href='"+data.public_path+"' target='_blank'><i class='fa fa-blue fa-file-pdf-o'></i> "+data.name+"</a></li>");
		}
	},

	remove: function(id) {
		$("#purchaseBlock_"+id).remove();
		
		if($('#fastpurchasesList .purchaseBlock').length === 1) {
			$('.deletePurchaseButton').hide();
		}
	},

	updateCurrency: function(indice) {
		var currency = $("#fpur_currency_"+indice+" option:selected").attr("symbol");
		$(".payCurrency_"+indice).html(currency);
	}
};